import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/languex-app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/about-us/components/AboutUsExcellence/AboutUsExcellence.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/about-us/components/AboutUsHero/AboutUsHero.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/about-us/components/AboutUsHumanConnection/AboutUsHumanConnection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/about-us/components/AboutUsOurRoots/AboutUsOurRoots.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/about-us/components/AboutUsSupport/AboutUsSupport.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/languex-app/src/components/screen/about-us/components/AboutUsTeam/AboutUsTeam.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/languex-app/src/components/screen/global-components/logo/Logo-trust.tsx");
